var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { elementInstance } from "../instance.mjs";
import { loadStripeIfNeeded } from "./utils.mjs";
import { initializeStripeExpressElements } from "./expressElements.mjs";
export const expressCheckoutElementId = 'stripe-express-checkout-container';
export const paymentElementId = 'stripe-payment-container';
export const initializeStripeElements = (state, actions, cartCheckout, cartPayment) => __awaiter(void 0, void 0, void 0, function* () {
    initializeStripeExpressElements(state, cartCheckout, cartPayment);
    elementInstance({
        elementId: paymentElementId,
        idempotencyKey: state.id + state.version + paymentIntentClientSecret(state),
        onMount: (e) => __awaiter(void 0, void 0, void 0, function* () {
            const stripe = yield loadStripeIfNeeded(cartPayment);
            const elements = stripe.elements({
                appearance: {
                // Set stuff here if needed to control the look and feel of the elements
                },
                clientSecret: paymentIntentClientSecret(state),
            });
            const paymentElement = elements.create('payment', {
            // Set stuff here if needed, eg applePay config
            });
            paymentElement.mount(e);
            actions.setCompletePurchaseHandler(() => __awaiter(void 0, void 0, void 0, function* () {
                const { error } = yield stripe.confirmPayment({
                    elements,
                    confirmParams: {
                        // Stripe will include query params to this url that we pick up on and check for a
                        // status update on the payment intent
                        return_url: state.checkoutPageUrl,
                    },
                });
                if (error) {
                    return {
                        $type: 'validationError',
                        errors: [{ message: error.message || 'Payment failed' }],
                    };
                }
                // No need to do anything here because in this case the payment was successful and the
                // user will be redirected
            }));
            return () => {
                paymentElement.unmount();
            };
        }),
    });
});
export const paymentIntentClientSecret = (state) => {
    var _a, _b;
    if (((_b = (_a = state.checkout) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.$type) !== 'stripeCheckout') {
        state.onUnexpectedError('Invalid payment type');
        throw new Error('Invalid payment type');
    }
    return state.checkout.payment.elements.paymentIntentClientSecret;
};
//# sourceMappingURL=elements.js.map